import Vue from 'vue'
import deviceUtils from './deviceUtils'

const authorizationUtils = {
  /* 用户认证 */
  toAuthorize: function (router) {
    let redirect = router.currentRoute.path
    router.replace('/authorize?redirect=' + decodeURIComponent(redirect))
    Vue.nextTick(() => this.toWeChatAuth(redirect))
  },
  /* 微信授权 */
  toWeChatAuth: function (redirect) {
    if (deviceUtils.isWeChatBrowser()) {
      Vue.prototype.$ajax({
        url: '/index/m/ws/auth',
        method: 'post',
        data: Vue.prototype.$qs.stringify({
          redirect: decodeURIComponent(redirect || '')
        })
      }).then(response => {
        if (response.data) {
          let authorizeUrl = response.data['authorizeUrl']
          if (authorizeUrl) {
            window.location.href = authorizeUrl
          }
        }
      })
    }
  }
}

export default authorizationUtils



// WEBPACK FOOTER //
// ./src/util/authorizationUtils.js